<template>
  <div>
    <nav-bar title="Surveys" />
    <div class="mobile none-padding-mobile pt-4 position-relative">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <surveys-skeleton></surveys-skeleton>
          </template>
          <div>
            <survey-list v-if="surveyList.length" :surveyList="surveyList"></survey-list>
            <without-surveys v-else></without-surveys>
          </div>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import SurveysSkeleton from '@/module/components/skeletons/SurveysSkeleton';
import SurveyList from '@/module/components/SurveyList';
import WithoutSurveys from '@/module/components/WithoutSurveys';
import { getSurveys } from '@/module/services';

export default {
  components: {
    NavBar,
    SurveysSkeleton,
    WithoutSurveys,
    SurveyList,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      loading: true,
      sessionStore,
      surveyList: [],
    };
  },
  async mounted() {
    try {
      this.loading = true;
      this.surveyList = await getSurveys();
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped></style>
